// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._4aV14rpxx{display:flex;flex-direction:column;flex:1}.LIbakioCx{flex-grow:1;min-height:calc(40vh - 40px);display:flex;flex-direction:column;align-items:center;justify-content:center}._8bJjhSAPx{font-weight:bold;font-size:22px;padding:10px;color:var(--primary-text);text-align:center}._5mAHHOxLx{display:flex;flex-direction:column;min-height:60vh;padding:0 20px 20px 20px}._3uV3hh2Qx{font-size:20px;color:var(--primary-text);text-align:center;padding-bottom:20px}._4QoCYxe9x{margin-bottom:10px}._4iIN0iAbx{display:flex;flex-direction:row}._2Mbd39mhx{color:var(--hint-text)}._49ZSv4iIx{flex:1;display:flex;flex-direction:column;padding:10px}._1qnR8FXZx{padding:10px}._5KfGPIdMx{color:var(--primary-text)}._3HMWCAIGx{margin-top:auto}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"main": "_4aV14rpxx",
	"top": "LIbakioCx",
	"app-display-name": "_8bJjhSAPx",
	"appDisplayName": "_8bJjhSAPx",
	"bottom": "_5mAHHOxLx",
	"choose-account": "_3uV3hh2Qx",
	"chooseAccount": "_3uV3hh2Qx",
	"user": "_4QoCYxe9x",
	"account-picker": "_4iIN0iAbx",
	"accountPicker": "_4iIN0iAbx",
	"sign-in-as": "_2Mbd39mhx",
	"signInAs": "_2Mbd39mhx",
	"user-info": "_49ZSv4iIx",
	"userInfo": "_49ZSv4iIx",
	"gravatar": "_1qnR8FXZx",
	"email-dark": "_5KfGPIdMx",
	"emailDark": "_5KfGPIdMx",
	"footer": "_3HMWCAIGx"
};
module.exports = exports;
